// Import all self-executing dependencies
// ------------------------------------------------------------------------- /
import 'animate.css'
import 'core-js/actual'

import { nl } from 'date-fns/locale'
import setDefaultOptions from 'date-fns/setDefaultOptions'
import 'the-new-css-reset/css/reset.css'

import './@bothrs-ui/web/styles'
import './styles/layout/page-layout.scss'
import './styles/root.scss'

// Set date-fns default options
setDefaultOptions({ locale: nl })
